export default __webpack_public_path__ + "static/media/salesverse.88bf070f.png";